require('intersection-observer')

// Import style
require('./../scss/main.scss')

// Create SVG sprite
require.context('./../svg/sprite-optimized?optimized', true, /\.svg$/)
// Create SVG sprite
require.context('./../svg/sprite-non-optimized?non-optimized', true, /\.svg$/)

// Create SVG isolated
require.context('./../svg/isolated?isolated', true, /\.svg$/)

// Images
//require.context('./../img', true)

//require.context('./../fonts', true)
// Videos
//require.context('./../videos', true)

Element.prototype.parents = function (selector) {

  var elements = []
  var elem = this
  var ishaveselector = selector !== undefined

  while ((elem = elem.parentElement) !== null) {
    if (elem.nodeType !== Node.ELEMENT_NODE) {
      continue
    }

    if (!ishaveselector || elem.matches(selector)) {
      elements.push(elem)
    }
  }

  return elements
}

window.getOffsetTop = function (elem) {
  let offsetTop = 0;
  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }
  } while (elem = elem.offsetParent);
  return offsetTop;
}

window.getOffsetLeft = function (elem) {
  let offsetLeft = 0;
  do {
    if (!isNaN(elem.offsetLeft)) {
      offsetLeft += elem.offsetLeft;
    }
  } while (elem = elem.offsetParent);
  return offsetLeft;
}

/**
 * Object-fit fallback
 */
if ('objectFit' in document.documentElement.style === false) {

  // assign HTMLCollection with parents of images with objectFit to variable
  const containers = [...document.querySelectorAll('.js-object-fit')]

  // Loop through HTMLCollection
  containers.forEach(container => {
    if (!container) return
    // Assign image source to variable
    let img;
    if ( container.tagName === "IMG" ) {
      img =  container
      container = img.parentNode
    } else {
      img = container.querySelector("img")
    }

    // Hide image
    img.style.display = 'none'
    // BG cover style
    container.style.backgroundSize = 'cover'
    container.style.backgroundImage = 'url(' + img.src + ')'
    container.style.backgroundPosition = 'center center'
  })

}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

/*window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/!**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 *!/

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}*/

import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))



require('./oldstuff')
